export default __webpack_public_path__ + "static/media/B73.3ae4af99.png";